import UserEffect from "./UserEffect";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import { ReduxDispatch } from "../../models/ReduxProps";
import UserModel from "./models/UserModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import UserLoginRequestModel from "./models/UserLoginRequestModel";
import UserRegistrationRequestModel from "./models/UserRegistrationRequestModel";
import UserRegistrationConfirmRequestModel from "./models/UserRegistrationConfirmRequestModel";
import UserResponseInfoModel from "./models/UserInfoModel";
import ResponseAuthTokensModel from "stores/shared/models/ResponseAuthTokensModel";
import RecuperoPasswordRequestModel from "./models/RecuperoPasswordRequestModel";
import CambioPasswordRequestModel from "./models/CambioPasswordRequestModel";
import UserRegistrationRinvioMail from "./models/UserRegistrationRinvioMail";
import RicercaPreventivoViewModel from "stores/preventivo/models/RicercaPreventivoViewModel";
//import RegistrationAnonyousModel from "./models/RegistrationAnonymousModel";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | UserModel
    | ResponseAuthTokensModel
    | ResponseEsitoModel
    | UserResponseInfoModel;
// | RegistrationAnonyousModel;

export default class UserAction {
    public static readonly SET_COOKIE_CONSENT: string = "UserAction.SET_COOKIE_CONSENT";
    public static readonly SET_COOKIE_CONSENT_FINISHED: string = "UserAction.SET_COOKIE_CONSENT_FINISHED";

    public static readonly REQUEST_USER_LOGIN: string = "UserAction.REQUEST_USER_LOGIN";
    public static readonly REQUEST_USER_LOGIN_FINISHED: string = "UserAction.REQUEST_USER_LOGIN_FINISHED";

    public static readonly SET_USER_LOGIN_REQUIRED: string = "UserAction.SET_USER_LOGIN_REQUIRED";
    public static readonly SET_USER_LOGIN_REQUIRED_FINISHED: string = "UserAction.SET_USER_LOGIN_REQUIRED_FINISHED";

    public static readonly SET_USER_LOGIN: string = "UserAction.SET_USER_LOGIN";
    public static readonly SET_USER_LOGIN_FINISHED: string = "UserAction.SET_USER_LOGIN_FINISHED";

    public static readonly SET_USER_LOGOUT: string = "UserAction.SET_USER_LOGOUT";
    public static readonly SET_USER_LOGOUT_FINISHED: string = "UserAction.SET_USER_LOGOUT_FINISHED";

    public static readonly REQUEST_USER_REGISTRATION: string = "UserAction.REQUEST_USER_REGISTRATION";
    public static readonly REQUEST_USER_REGISTRATION_FINISHED: string = "UserAction.REQUEST_USER_REGISTRATION_FINISHED";

    public static readonly REQUEST_VERIFICA_TOKEN: string = "UserAction.REQUEST_VERIFICA_TOKEN";
    public static readonly REQUEST_VERIFICA_TOKEN_FINISHED: string = "UserAction.REQUEST_VERIFICA_TOKEN_FINISHED";

    public static readonly REQUEST_USER_REGISTRATION_CONFIRM: string = "UserAction.REQUEST_USER_REGISTRATION_CONFIRM";
    public static readonly REQUEST_USER_REGISTRATION_CONFIRM_FINISHED: string =
        "UserAction.REQUEST_USER_REGISTRATION_CONFIRM_FINISHED";

    public static readonly REQUEST_GET_INFO_UTENTE: string = "UserAction.REQUEST_GET_INFO_UTENTE";
    public static readonly REQUEST_GET_INFO_UTENTE_FINISHED: string = "UserAction.REQUEST_GET_INFO_UTENTE_FINISHED";

    public static readonly REQUEST_USER_DELETE: string = "UserAction.REQUEST_USER_DELETE";
    public static readonly REQUEST_USER_DELETE_FINISHED: string = "UserAction.REQUEST_USER_DELETE_FINISHED";

    public static readonly REQUEST_USER_RECUPERO_PASSWORD: string = "UserAction.REQUEST_USER_RECUPERO_PASSWORD";
    public static readonly REQUEST_USER_RECUPERO_PASSWORD_FINISHED: string =
        "UserAction.REQUEST_USER_RECUPERO_PASSWORD_FINISHED";

    public static readonly REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD: string =
        "UserAction.REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD";
    public static readonly REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD_FINISHED: string =
        "UserAction.REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD_FINISHED";

    public static readonly REQUEST_USER_CAMBIO_PASSWORD: string = "UserAction.REQUEST_USER_CAMBIO_PASSWORD";
    public static readonly REQUEST_USER_CAMBIO_PASSWORD_FINISHED: string =
        "UserAction.REQUEST_USER_CAMBIO_PASSWORD_FINISHED";

    public static readonly REQUEST_USER_RINVIO_REGISTRATION: string = "UserAction.REQUEST_USER_RINVIO_REGISTRATION";
    public static readonly REQUEST_USER_RINVIO_REGISTRATION_FINISHED: string =
        "UserAction.REQUEST_USER_RINVIO_REGISTRATION_FINISHED";

    /*    public static readonly REQUEST_USER_REGISTRATION_ANONYMOUS: string = "UserAction.REQUEST_USER_REGISTRATION_ANONYMOUS";
    public static readonly REQUEST_USER_REGISTRATION_ANONYMOUS_FINISHED: string =
            "UserAction.REQUEST_USER_REGISTRATION_ANONYMOUS_FINISHED";
     */
    public static readonly REQUEST_SET_USER_REGISTRATION_MODEL: string =
        "UserAction.REQUEST_SET_USER_REGISTRATION_MODEL";
    public static readonly REQUEST_SET_USER_REGISTRATION_MODEL_FINISHED: string =
        "UserAction.REQUEST_SET_USER_REGISTRATION_MODEL_FINISHED";

    public static readonly REQUEST_SAVE_CONSENSI_USER: string = "UserAction.REQUEST_SAVE_CONSENSI_USER";
    public static readonly REQUEST_SAVE_CONSENSI_USER_FINISHED: string =
        "UserAction.REQUEST_SAVE_CONSENSI_USER_FINISHED";

    public static readonly REQUEST_ERROR: string = "UserAction.REQUEST_ERROR";
    public static readonly REQUEST_ERROR_FINISHED: string = "UserAction.REQUEST_ERROR_FINISHED";

    public static setCookieConsent(consent: boolean): any {
        return ActionUtility.createAction(UserAction.SET_COOKIE_CONSENT_FINISHED, consent);
    }

    public static requestUserLogin(request: UserLoginRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseAuthTokensModel>(
                dispatch,
                UserAction.REQUEST_USER_LOGIN,
                UserEffect.requestUserLogin,
                request
            );
        };
    }

    public static setUserLoginRequired(required: boolean): any {
        return ActionUtility.createAction(UserAction.SET_USER_LOGIN_REQUIRED_FINISHED, required);
    }

    public static setUserLogin(): any {
        return ActionUtility.createAction(UserAction.SET_USER_LOGIN_FINISHED);
    }

    public static setUserLogout(): any {
        return ActionUtility.createAction(UserAction.SET_USER_LOGOUT_FINISHED);
    }

    public static requestUserRegistration(userRegistration: UserRegistrationRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UserAction.REQUEST_USER_REGISTRATION,
                UserEffect.requestUserRegistration,
                userRegistration
            );
        };
    }

    public static requestVerificaToken(token: String): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UserAction.REQUEST_VERIFICA_TOKEN,
                UserEffect.requestVerificaToken,
                token
            );
        };
    }

    public static requestUserRegistrationConfirm(userRegistrationConfirm: UserRegistrationConfirmRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UserAction.REQUEST_USER_REGISTRATION_CONFIRM,
                UserEffect.requestUserRegistrationConfirm,
                userRegistrationConfirm
            );
        };
    }

    public static requestGetInfoUtente(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<UserResponseInfoModel>(
                dispatch,
                UserAction.REQUEST_GET_INFO_UTENTE,
                UserEffect.requestGetInfoUtente
            );
        };
    }

    public static requestUserDelete(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UserAction.REQUEST_USER_DELETE,
                UserEffect.requestUserDelete
            );
        };
    }

    public static requestUserRecuperoPassword(request: RecuperoPasswordRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UserAction.REQUEST_USER_RECUPERO_PASSWORD,
                UserEffect.requestUserRecuperoPassword,
                request
            );
        };
    }

    public static requestVerificaTokenRecuperoPassword(token: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UserAction.REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD,
                UserEffect.requestUserVerificaTokenRecuperoPassword,
                token
            );
        };
    }

    public static requestUserCambioPassword(request: CambioPasswordRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UserAction.REQUEST_USER_CAMBIO_PASSWORD,
                UserEffect.requestUserCambioPassword,
                request
            );
        };
    }

    public static requestUserRinvioEmail(userRegistration: UserRegistrationRinvioMail): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UserAction.REQUEST_USER_RINVIO_REGISTRATION,
                UserEffect.requestUserRinvioEmail,
                userRegistration
            );
        };
    }

    public static setUserRegistration(filtri: RicercaPreventivoViewModel): any {
        return ActionUtility.createAction(UserAction.REQUEST_SET_USER_REGISTRATION_MODEL_FINISHED);
    }
    public static requesSaveConsesiUtenteConfirm(consensi: UserRegistrationRequestModel): any {
        console.log("action");
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UserAction.REQUEST_SAVE_CONSENSI_USER,
                UserEffect.requesSaveConsesiUtenteConfirm,
                consensi
            );
        };
    }

    public static requestError(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<any>(dispatch, UserAction.REQUEST_ERROR, UserEffect.requestError);
        };
    }
}
